/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface DosespotPrescriptionDetails {
  substitute_allowed?: boolean | null;
  effective_date?: string | null;
  last_fill_date?: string | null;
  days_supply?: number | null;
  directions?: string | null;
  dispense_unit_description?: string | null;
  dispense_unit_id?: number | null;
  quantity?: string | null;
  refills?: string | null;
  written_date?: string | null;
  dose_form?: string | null;
  route?: string | null;
  strength?: string | null;
  generic_drug_name?: string | null;
  dispensable_drug_id?: number | null;
  brand?: boolean | null;
  rx_cui?: string | null;
  otc?: boolean | null;
  ndc?: string | null;
  schedule?: number | null;
  display_name?: string | null;
  drug_classification?: string | null;
  pharmacy_notes?: string | null;
}
